import {
  Banner as DixaBanner,
  Box,
  Button,
  Text,
} from '@dixa/lib-shared-habla';
import { ArticleDataContext } from 'articleEditor/contexts/articleDataProvider';
import { ArticleDetachModal } from 'articleEditor/modals/articleDetachModal';
import { useModal } from 'lib-knowledge-modal';
import { useContext } from 'react';

type ArticleDetachBanner = {
  articleId: string;
  isSyncedWithElevio: boolean;
};
export function ArticleDetachBanner(): JSX.Element | null {
  const { showModal } = useModal();
  const { id: articleId } = useContext(ArticleDataContext);
  const articleData = useContext(ArticleDataContext);

  if (!articleData || !articleData?.isSyncedWithElevio) return null;

  function onDetach() {
    showModal(ArticleDetachModal, { articleId });
  }

  return (
    <Box margin="0 0 300">
      <DixaBanner
        description={
          <>
            <Text.Paragraph variant="4">
              This article was imported from Elevio and can not be edited.
            </Text.Paragraph>
            <Text.Paragraph variant="4">
              To make changes please detach the article.
            </Text.Paragraph>
          </>
        }
        variant="info"
        actionSlot={
          <Button variant="secondary" onClick={onDetach}>
            Detach article
          </Button>
        }
      />
    </Box>
  );
}
